/**
 * Вывод блока сравнения
 *
 * @package citrus.config
 */
const TEMPLATE_PATH = "/local/templates/corp/";
let SITE_CONFIG = {
	TEMPLATE_PATH: TEMPLATE_PATH,
	SVG_PATH: TEMPLATE_PATH + "app/assets/dist/icons/sprite.svg",
};

export let IconManager = function (icon = '') {
	return '<use x="0" y="0" xlink:href="' + SITE_CONFIG.SVG_PATH + '#icons--' + icon + '" ></use>';
};

export {SITE_CONFIG};
export default {SITE_CONFIG, IconManager};
